import {
  Steps,
  StepsContents,
  StepsIndicator,
  StepsList
} from '@library/components/progress/Steps';
import { MissionConditionsForm } from '@bo-components/missions/MissionConditionsForm';
import { MissionDetailsForm } from '@bo-components/missions/MissionDetailsForm';
import { MissionEventsForm } from '@bo-components/missions/MissionEventsForm';
import { PageTitle } from '@library/components/PageTitle';

export const CreateMission = () => {
  return (
    <div className="flex w-auto max-w-4xl flex-col gap-4 px-6 pb-2 pt-3">
      <PageTitle title="Create Mission" />

      <Steps defaultStep="details">
        <StepsList>
          <StepsIndicator step="details">Mission Details</StepsIndicator>
          <StepsIndicator step="events">Member Events</StepsIndicator>
          <StepsIndicator step="conditions">Event Conditions</StepsIndicator>
        </StepsList>
        <StepsContents step="details">
          <MissionDetailsForm />
        </StepsContents>
        <StepsContents step="events">
          <MissionEventsForm />
        </StepsContents>
        <StepsContents step="conditions">
          <MissionConditionsForm />
        </StepsContents>
      </Steps>
    </div>
  );
};
